import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, InfinityIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const MOCKUP_SRC = 'https://cdn.magicpatterns.com/uploads/urmAUFLxkpqtXbpPsHt4K3/ChatGPT_Image_12_sept_2026,_16_36_13-Photoroom.png';
export function HeroSection() {
  return <section id="top" aria-labelledby="hero-title" className="flex min-h-[calc(100svh-2.25rem)] items-center bg-brand-cream px-4 py-8 md:px-8" data-id="element-125" data-mp="28uo80bl4uh35">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto grid w-full max-w-content items-center gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:gap-10" data-id="element-126" data-mp="30lk9yh5nn1bn">
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-127" data-mp="3fibawuuz8l3d">
          <p className="mb-3 text-[10px] font-extrabold uppercase tracking-[0.16em] text-brand-teal sm:text-xs" data-id="element-128" data-mp="3k9tabehcqdm8">
            PRIMARIA, MEDIE E SUPERIORI · ETÀ 6-19 ANNI
          </p>
          <h1 id="hero-title" className="text-[1.85rem] font-extrabold leading-[1.08] tracking-tight text-brand-primary sm:text-[2.4rem] lg:text-[3.1rem]" data-id="element-129" data-mp="2be6tc816zmrc">
            Insegna un Anno Intero di <span className="italic text-brand-accent" data-id="element-130" data-mp="2ked3bjxom4lr">Educazione Fisica</span> in Soli 5
            Minuti di Preparazione
          </h1>
          <p className="mt-4 max-w-lg text-[13px] leading-relaxed text-brand-gray sm:text-sm lg:text-base" data-id="element-131" data-mp="2z1oevltv5olv">
            <strong className="font-bold text-brand-text" data-id="element-132" data-mp="2u6iuwsk0uk0f">EDUCAZIONE FISICA PRONTA™</strong> è il{' '}
            <strong className="font-bold text-brand-text" data-id="element-133" data-mp="3823cnko0kw69">curricolo motorio completo</strong>, pronto all&apos;uso, per
            la scuola italiana. <strong className="font-bold text-brand-text" data-id="element-134" data-mp="1dpn0k38jenth">8 volumi</strong>,{' '}
            <strong className="font-bold text-brand-text" data-id="element-135" data-mp="18r3du0m4d802">64 unità didattiche</strong>,{' '}
            <strong className="font-bold text-brand-text" data-id="element-136" data-mp="18tfzoov002ie">2.752 esercizi già pronti</strong>: zero ore a preparare le
            lezioni da zero.
          </p>

          <img src={MOCKUP_SRC} alt="Il pacchetto EDUCAZIONE FISICA PRONTA: gli 8 volumi, i materiali digitali su tablet e computer e i 5 bonus inclusi" className="mx-auto my-5 h-[34svh] w-auto max-w-full object-contain sm:h-[38svh] lg:hidden" data-id="element-137" data-mp="3dsxy2utod5b1" />

          <div className="mt-2 flex w-full flex-col items-center lg:mt-8 lg:items-start" data-id="element-138" data-mp="3rre56mvg8xtp">
            <CTAButton className="w-full max-w-sm px-5 py-4 text-[11px] sm:text-xs lg:w-auto lg:text-sm" data-id="element-139" data-mp="kulei7mxxj9" />
            <p className="mt-2.5 text-[10px] font-semibold leading-relaxed text-brand-gray" data-id="element-140" data-mp="5dxdsn0of0xv">
              ✓ Pagamento unico <span className="px-1 text-brand-yellow" data-id="element-141" data-mp="ab61f34lfx6i">·</span> ✓ Accesso immediato
              <span className="px-1 text-brand-yellow" data-id="element-142" data-mp="eeltrn9mrbde">·</span> ✓ Pronto da stampare
            </p>
            <p className="mt-2 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[10px] text-brand-gray lg:justify-start" data-id="element-143" data-mp="jd5i1ubp4z8x">
              <span className="inline-flex items-center gap-1" data-id="element-144" data-mp="23s1wi8122400">
                <DownloadIcon className="h-3 w-3 text-brand-teal" strokeWidth={2} aria-hidden="true" data-id="element-145" data-mp="1yujzng0bbf8d" />
                Download immediato
              </span>
              <span aria-hidden="true" data-id="element-146" data-mp="1puwvimg77vbm">·</span>
              <span className="inline-flex items-center gap-1" data-id="element-147" data-mp="1pw7xcgq32t03">
                <InfinityIcon className="h-3 w-3 text-brand-teal" strokeWidth={2} aria-hidden="true" data-id="element-148" data-mp="2mlfnk21ndqac" />
                Accesso a vita
              </span>
              <span aria-hidden="true" data-id="element-149" data-mp="2ilf608j94yz2">·</span>
              <span className="inline-flex items-center gap-1" data-id="element-150" data-mp="2drssyf96et2q">
                <ShieldCheckIcon className="h-3 w-3 text-brand-teal" strokeWidth={2} aria-hidden="true" data-id="element-151" data-mp="2dq9e8t364q32" />
                Garanzia 30 giorni
              </span>
            </p>
          </div>
        </div>

        <img src={MOCKUP_SRC} alt="" aria-hidden="true" className="hidden max-h-[86svh] w-full object-contain lg:block" data-id="element-152" data-mp="31i6oifqyza22" />
      </motion.div>
    </section>;
}